<template>
  <div class="profitSettle">
    <div class="top" style="border-bottom: 1px solid #dcdfe6">
      <div class="dimension-filter" style="display: flex; align-items: center; flex-wrap: wrap">
        <span class="label">查询维度</span>
        <el-button
          type="text"
          :class="groupBy === 'STATION' ? 'active' : ''"
          @click="chooseDimension('STATION')"
        >按场站</el-button>
        <el-button
          type="text"
          :class="groupBy === 'TARGET' ? 'active' : ''"
          @click="chooseDimension('TARGET')"
        >按分润方</el-button>
      </div>
      <div class="time-filter" style="display: flex; align-items: center; flex-wrap: wrap; margin-top: 10px">
        <span class="label">统计时间</span>
        <el-button
          type="text"
          :class="timeType === 'DAY' ? 'active' : ''"
          @click="chooseType('DAY')"
        >今日</el-button>
        <el-button
          type="text"
          :class="timeType === 'MONTH' ? 'active' : ''"
          @click="chooseType('MONTH')"
        >本月</el-button>
        <el-button
          type="text"
          :class="timeType === 'YEAR' ? 'active' : ''"
          @click="chooseType('YEAR')"
        >本年</el-button>
        <el-button
          type="text"
          :class="timeType === 'ALL' ? 'active' : ''"
          @click="chooseType('ALL')"
        >全部</el-button>
        <span class="label">自定义</span>
        <el-date-picker
          v-model="form.date1"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="开始日期"
          size="small"
          style="width: 140px"
        />
        <span style="margin: 0 6px">至</span>
        <el-date-picker
          v-model="form.date2"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="结束日期"
          size="small"
          style="width: 140px"
        />
        <el-form :inline="true" :model="formInline" size="medium" style="margin-left: 20px">
          <el-form-item v-if="groupBy === 'STATION'" label="场站名称">
            <el-input v-model="formInline.stationName" placeholder="请输入场站名称" style="width: 160px" clearable />
          </el-form-item>
          <el-form-item v-else label="分润方名称">
            <el-input v-model="formInline.targetName" placeholder="请输入分润方名称" style="width: 160px" clearable />
          </el-form-item>
          <el-form-item label="是否结算">
            <el-select v-model="formInline.settled" placeholder="请选择" clearable style="width: 110px">
              <el-option label="未结算" :value="0" />
              <el-option label="已结算" :value="1" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content" style="position: relative">
      <el-button type="warning" style="margin-top: 20px" :disabled="selectedOrders.length === 0" @click="settleOrders">批量结算选中订单</el-button>
      <span class="tip">勾选展开行中的订单可进行整单结算</span>
      <el-table
        :data="tableData"
        stripe
        border
        style="width: 100%; margin-top: 20px"
        row-key="key"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="order-box">
              <div class="order-title">
                <span>{{ groupBy === 'STATION' ? '场站' : '分润方' }}：{{ groupBy === 'STATION' ? props.row.stationName : props.row.targetName }}</span>
              </div>
              <el-table
                :data="props.row.orders"
                stripe
                border
                size="small"
                style="width: 100%"
                @selection-change="val => handleOrderSelection(props.row, val)"
              >
                <el-table-column type="selection" align="center" width="50" :selectable="order => order.settled !== 1" />
                <el-table-column type="index" align="center" width="50" label="序号" />
                <el-table-column label="充电单号" align="center" min-width="130">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="gotoDetail(scope.row)">{{ scope.row.startChargeSeq }}</el-button>
                  </template>
                </el-table-column>
                <el-table-column label="充电枪编码" align="center" min-width="100">
                  <template slot-scope="scope">
                    <span>{{ scope.row.connectorID }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="用户归属企业" align="center" min-width="110">
                  <template slot-scope="scope">
                    <span>{{ scope.row.accountOrgName }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="支付时间" align="center" min-width="140">
                  <template slot-scope="scope">
                    <span>{{ scope.row.payTime }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="充电度数" align="center" width="90">
                  <template slot-scope="scope">
                    <span>{{ getFloat(scope.row.power) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="实收电费" align="center" width="100">
                  <template slot-scope="scope">
                    <span>{{ getFixed2(scope.row.elecMoney) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="实收服务费" align="center" width="100">
                  <template slot-scope="scope">
                    <span>{{ getFixed2(scope.row.serviceMoney) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="是否结算" align="center" width="90">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.settled === 1 ? 'success' : 'info'">
                      {{ scope.row.settled === 1 ? '已结算' : '未结算' }}
                    </el-tag>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column type="index" align="center" width="60" label="序号" />
        <el-table-column v-if="groupBy === 'STATION'" label="场站名称" align="center" min-width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="gotoOrderDetail(scope.row)">{{ scope.row.stationName }}</el-button>
          </template>
        </el-table-column>
        <el-table-column v-if="groupBy === 'TARGET'" label="分润方名称" align="center" min-width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="gotoOrderDetail(scope.row)">{{ scope.row.targetName }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="充电度数" align="center" width="100">
          <template slot-scope="scope">
            <span>{{ getFloat(scope.row.power) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="实收电费" align="center" width="110">
          <template slot-scope="scope">
            <span>{{ getFixed2(scope.row.elecMoney) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="实收服务费" align="center" width="110">
          <template slot-scope="scope">
            <span>{{ getFixed2(scope.row.serviceMoney) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="分润金额" align="center" width="110">
          <template slot-scope="scope">
            <span>{{ getFloat(scope.row.amount) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="结算状态" align="center" width="110">
          <template slot-scope="scope">
            <el-tag :type="scope.row.allSettled === 1 ? 'success' : 'warning'">
              {{ scope.row.allSettled === 1 ? '已全部结算' : '存在未结算' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="110" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="gotoOrderDetail(scope.row)">订单明细</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      v-if="pageshow"
      style="margin-top: 20px"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  name: 'ProfitSettle',
  data() {
    return {
      groupBy: 'STATION',
      timeType: 'DAY',
      form: {
        date1: '',
        date2: ''
      },
      formInline: {
        stationName: '',
        targetName: '',
        settled: ''
      },
      tableData: [],
      selectedOrders: [],
      pageshow: true,
      currentPage: 1,
      total: 0,
      pagesize: 10
    }
  },
  mounted() {
    this.getPageData()
  },
  methods: {
    chooseDimension(val) {
      this.groupBy = val
      this.formInline.stationName = ''
      this.formInline.targetName = ''
      this.currentPage = 1
      this.onSubmit()
    },
    chooseType(val) {
      this.timeType = val
      this.form.date1 = ''
      this.form.date2 = ''
    },
    reset() {
      this.groupBy = 'STATION'
      this.timeType = 'DAY'
      this.form.date1 = ''
      this.form.date2 = ''
      this.formInline.stationName = ''
      this.formInline.targetName = ''
      this.formInline.settled = ''
      this.currentPage = 1
      this.onSubmit()
    },
    onSubmit() {
      this.currentPage = 1
      this.getPageData()
    },
    handleSizeChange(val) {
      this.pageshow = false
      this.pagesize = val
      this.tableData = []
      this.getPageData()
    },
    handleCurrentChange(val) {
      this.pageshow = false
      this.currentPage = val
      this.tableData = []
      this.getPageData()
    },
    getPageData() {
      const data = {
        pageNo: this.currentPage,
        pageSize: this.pagesize,
        groupBy: this.groupBy,
        timeType: this.timeType,
        startTime: this.form.date1,
        endTime: this.form.date2,
        stationName: this.formInline.stationName,
        targetName: this.formInline.targetName,
        settled: this.formInline.settled
      }
      this.$store.dispatch('form/handle', {
        url: '/finance/profit/settle/records',
        data: data,
        method: 'get',
        callback: resp => {
          if (resp.list && resp.list.length > 0) {
            this.tableData = resp.list
            this.pageshow = true
          } else {
            this.pageshow = false
            this.tableData = []
          }
          this.currentPage = resp.pageNo
          this.total = resp.count
          this.pagesize = resp.pageSize
        }
      })
    },
    handleOrderSelection(row, val) {
      this.$set(row, 'selectedOrders', val)
    },
    settleOrders() {
      const orderIds = []
      this.tableData.forEach(row => {
        if (row.selectedOrders && row.selectedOrders.length > 0) {
          row.selectedOrders.forEach(order => {
            if (order.settled !== 1 && orderIds.indexOf(order.orderId) === -1) {
              orderIds.push(order.orderId)
            }
          })
        }
      })
      if (orderIds.length === 0) {
        this.$notify({
          title: '提示',
          message: '请先勾选要结算的订单',
          type: 'warning'
        })
        return
      }
      this.$confirm('确定要将选中的 ' + orderIds.length + ' 笔订单标记为已结算吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('form/handle', {
          url: '/finance/profit/settle',
          data: orderIds,
          method: 'post',
          callback: () => {
            this.$notify({
              title: '成功',
              message: '结算成功',
              type: 'success'
            })
            this.getPageData()
          }
        })
      }).catch(() => {})
    },
    gotoDetail(item) {
      this.$router.push({
        path: '/orderManagement/historyDetail',
        query: { data: item.orderId, num: item.startChargeSeq }
      })
    },
    gotoOrderDetail(row) {
      const query = {
        timeType: this.timeType,
        startTime: this.form.date1,
        endTime: this.form.date2
      }
      if (this.groupBy === 'TARGET') {
        query.targetId = row.targetId
        query.targetName = row.targetName
      } else {
        query.stationId = row.stationId
        query.stationName = row.stationName
      }
      this.$router.push({
        path: '/ticketManagement/payDetail',
        query: query
      })
    }
  }
}
</script>

<style lang="less" scoped>
.profitSettle {
  .dimension-filter,
  .time-filter {
    .label {
      margin-right: 10px;
      font-size: 14px;
      color: #333;
    }
    .active {
      color: #409eff;
      border-bottom: 2px solid #409eff;
    }
    .el-button--text {
      width: 70px;
    }
    .el-form {
      display: flex;
      align-items: center;
      .el-form-item {
        margin-bottom: 0;
        margin-right: 15px;
      }
    }
  }
  .content {
    .tip {
      margin-left: 15px;
      font-size: 12px;
      color: #909399;
    }
    .order-box {
      padding: 10px 20px;
      background: #fafafa;
      .order-title {
        margin-bottom: 10px;
        font-size: 14px;
        color: #606266;
        font-weight: 600;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ticketManagement/profitSettle.vue